import { MEDIA } from "@/styles/common";
import { Flex } from "@chakra-ui/react";
import { usePaymentRoomState, useSetIsPaidRoom } from "./../../../shared/client/states/paymentRoom.state";
import { Price, RoomDetail } from "./components";
import { CustomWrapper } from "./paymentCard.style";
import { PaymentCardProps } from "./types/paymentCard.prop";
export const PaymentCard = ({ ...rest }: PaymentCardProps) => {
    const [paidRoomValue, setPaidRoomValue] = usePaymentRoomState();
    const setIsPaidRoomValue = useSetIsPaidRoom();
    const { roomIdx, addPeople, roomDetailInfo, imgUrl, date, finalPrice, discountPrice } = { ...rest };

    const handleDeleteRoom = () => {
        if (confirm("정말 삭제하시겠습니까?")) {
            const newRoomList = paidRoomValue.filter((it) => it.roomIdx !== roomIdx);
            setPaidRoomValue(newRoomList);
            setIsPaidRoomValue(true);
        }
    };

    const { isMobile } = MEDIA();

    return (
        <CustomWrapper flexDir={isMobile ? "column" : "row"}>
            <Flex width="100%" justifyContent="space-between" flexDir="column" rowGap="8px">
                <RoomDetail
                    roomDetailInfo={roomDetailInfo}
                    date={date}
                    addPeople={addPeople}
                    imgUrl={imgUrl}
                    handleDeleteRoom={handleDeleteRoom}
                />
                <Price finalPrice={finalPrice} discountPrice={discountPrice} />
            </Flex>
        </CustomWrapper>
    );
};
